/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBiensToParcCommand,
  AffectedQuotesResponse,
  BienImmobilierIdsResponse,
  BranchCode,
  CreateParcImmobilierCommandDto,
  CreateRealEstateCommandDto,
  CreateRealEstateWithQuestionsCommandDto,
  GetGenericListCommandDto,
  GetParcImmobilierResponseDto,
  GetRealEstateResponseDto,
  GetRealEstateTenantsResponse,
  GetRealEstateWithTenantsResponse,
  OperationResponse,
  ParcBienTypesResponse,
  ParcConfigDto,
  ParcTenancyFileResponse,
  ReadListParcsResponseDto,
  ReadListRealEstateDto,
  SearchBiensProprietaireResponse,
  SearchParcBiensCommand,
  SearchRealEstatesCommand,
  SearchRealEstatesResponse,
  UpdateRealEstateWithQuestionsCommandDto,
} from '../models/index';
import {
    AddBiensToParcCommandFromJSON,
    AddBiensToParcCommandToJSON,
    AffectedQuotesResponseFromJSON,
    AffectedQuotesResponseToJSON,
    BienImmobilierIdsResponseFromJSON,
    BienImmobilierIdsResponseToJSON,
    BranchCodeFromJSON,
    BranchCodeToJSON,
    CreateParcImmobilierCommandDtoFromJSON,
    CreateParcImmobilierCommandDtoToJSON,
    CreateRealEstateCommandDtoFromJSON,
    CreateRealEstateCommandDtoToJSON,
    CreateRealEstateWithQuestionsCommandDtoFromJSON,
    CreateRealEstateWithQuestionsCommandDtoToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetParcImmobilierResponseDtoFromJSON,
    GetParcImmobilierResponseDtoToJSON,
    GetRealEstateResponseDtoFromJSON,
    GetRealEstateResponseDtoToJSON,
    GetRealEstateTenantsResponseFromJSON,
    GetRealEstateTenantsResponseToJSON,
    GetRealEstateWithTenantsResponseFromJSON,
    GetRealEstateWithTenantsResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    ParcBienTypesResponseFromJSON,
    ParcBienTypesResponseToJSON,
    ParcConfigDtoFromJSON,
    ParcConfigDtoToJSON,
    ParcTenancyFileResponseFromJSON,
    ParcTenancyFileResponseToJSON,
    ReadListParcsResponseDtoFromJSON,
    ReadListParcsResponseDtoToJSON,
    ReadListRealEstateDtoFromJSON,
    ReadListRealEstateDtoToJSON,
    SearchBiensProprietaireResponseFromJSON,
    SearchBiensProprietaireResponseToJSON,
    SearchParcBiensCommandFromJSON,
    SearchParcBiensCommandToJSON,
    SearchRealEstatesCommandFromJSON,
    SearchRealEstatesCommandToJSON,
    SearchRealEstatesResponseFromJSON,
    SearchRealEstatesResponseToJSON,
    UpdateRealEstateWithQuestionsCommandDtoFromJSON,
    UpdateRealEstateWithQuestionsCommandDtoToJSON,
} from '../models/index';

export interface AddBienToParcRequest {
    parcId: string;
    bienId: string;
}

export interface AddBiensToParcRequest {
    parcId: string;
    addBiensToParcCommand: AddBiensToParcCommand;
}

export interface AssociatePersonToRealEstateRequest {
    bienId: string;
    personneId: string;
}

export interface CreateParcRequest {
    createParcImmobilierCommandDto: CreateParcImmobilierCommandDto;
}

export interface CreateRealEstateRequest {
    createRealEstateCommandDto: CreateRealEstateCommandDto;
}

export interface CreateRealEstateWithQuestionsRequest {
    createRealEstateWithQuestionsCommandDto: CreateRealEstateWithQuestionsCommandDto;
}

export interface DeleteParcRequest {
    parcId: string;
}

export interface ExcludeBienFromParcCoverageRequest {
    riskId: string;
    bienId: string;
}

export interface GetAffectedQuotesByRealEstateIdRequest {
    realEstateId: string;
}

export interface GetBienIdsByProprietaireRequest {
    personneId: string;
    search?: string;
    excludeParcId?: string;
}

export interface GetDevisImpactesByParcRequest {
    parcId: string;
}

export interface GetParcBienTypesRequest {
    riskId: string;
}

export interface GetParcByIdRequest {
    parcId: string;
}

export interface GetParcConfigRequest {
    riskId: string;
}

export interface GetParcTenancyFileRequest {
    riskId: string;
}

export interface GetRealEstateByContractIdRequest {
    contractId: string;
    codeBranche: BranchCode;
    includeQuestionnaire?: boolean;
}

export interface GetRealEstateByIdRequest {
    bienId: string;
    includeQuestionnaire?: boolean;
    codeBranche?: string;
}

export interface GetRealEstateByPersonIdRequest {
    personneId: string;
}

export interface GetTenantsRequest {
    riskId: string;
    bienId?: string;
}

export interface IncludeBienInParcCoverageRequest {
    riskId: string;
    bienId: string;
}

export interface RemoveBienFromParcRequest {
    parcId: string;
    bienId: string;
}

export interface RemovePersonFromRealEstateRequest {
    bienId: string;
    personneId: string;
}

export interface SaveParcConfigRequest {
    riskId: string;
    parcConfigDto: ParcConfigDto;
}

export interface SearchBiensByParcRequest {
    riskId: string;
    searchParcBiensCommand: SearchParcBiensCommand;
}

export interface SearchBiensByProprietaireRequest {
    personneId: string;
    getGenericListCommandDto: GetGenericListCommandDto;
    excludeParcId?: string;
}

export interface SearchRealEstatesRequest {
    searchRealEstatesCommand: SearchRealEstatesCommand;
}

export interface UpdateRealEstateWithQuestionsRequest {
    bienId: string;
    updateRealEstateWithQuestionsCommandDto: UpdateRealEstateWithQuestionsCommandDto;
}

/**
 * 
 */
export class RealEstateApi extends runtime.BaseAPI {

    /**
     * Add a real estate to a park (must belong to the park owner)
     */
    async addBienToParcRaw(requestParameters: AddBienToParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['parcId'] == null) {
            throw new runtime.RequiredError(
                'parcId',
                'Required parameter "parcId" was null or undefined when calling addBienToParc().'
            );
        }

        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling addBienToParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/{parcId}/biens/{bienId}`.replace(`{${"parcId"}}`, encodeURIComponent(String(requestParameters['parcId']))).replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Add a real estate to a park (must belong to the park owner)
     */
    async addBienToParc(requestParameters: AddBienToParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.addBienToParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add multiple real estates to a park (batch)
     */
    async addBiensToParcRaw(requestParameters: AddBiensToParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['parcId'] == null) {
            throw new runtime.RequiredError(
                'parcId',
                'Required parameter "parcId" was null or undefined when calling addBiensToParc().'
            );
        }

        if (requestParameters['addBiensToParcCommand'] == null) {
            throw new runtime.RequiredError(
                'addBiensToParcCommand',
                'Required parameter "addBiensToParcCommand" was null or undefined when calling addBiensToParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/{parcId}/biens`.replace(`{${"parcId"}}`, encodeURIComponent(String(requestParameters['parcId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddBiensToParcCommandToJSON(requestParameters['addBiensToParcCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Add multiple real estates to a park (batch)
     */
    async addBiensToParc(requestParameters: AddBiensToParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.addBiensToParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a person to a real estate property
     */
    async associatePersonToRealEstateRaw(requestParameters: AssociatePersonToRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling associatePersonToRealEstate().'
            );
        }

        if (requestParameters['personneId'] == null) {
            throw new runtime.RequiredError(
                'personneId',
                'Required parameter "personneId" was null or undefined when calling associatePersonToRealEstate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/{bienId}/personne/{personneId}`.replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))).replace(`{${"personneId"}}`, encodeURIComponent(String(requestParameters['personneId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Add a person to a real estate property
     */
    async associatePersonToRealEstate(requestParameters: AssociatePersonToRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.associatePersonToRealEstateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new real estate park
     */
    async createParcRaw(requestParameters: CreateParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createParcImmobilierCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createParcImmobilierCommandDto',
                'Required parameter "createParcImmobilierCommandDto" was null or undefined when calling createParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateParcImmobilierCommandDtoToJSON(requestParameters['createParcImmobilierCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a new real estate park
     */
    async createParc(requestParameters: CreateParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new real estate property
     */
    async createRealEstateRaw(requestParameters: CreateRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createRealEstateCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createRealEstateCommandDto',
                'Required parameter "createRealEstateCommandDto" was null or undefined when calling createRealEstate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRealEstateCommandDtoToJSON(requestParameters['createRealEstateCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a new real estate property
     */
    async createRealEstate(requestParameters: CreateRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createRealEstateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new real estate property along with associated questionnaire responses
     * Create real estate property with questionnaire responses
     */
    async createRealEstateWithQuestionsRaw(requestParameters: CreateRealEstateWithQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createRealEstateWithQuestionsCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createRealEstateWithQuestionsCommandDto',
                'Required parameter "createRealEstateWithQuestionsCommandDto" was null or undefined when calling createRealEstateWithQuestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRealEstateWithQuestionsCommandDtoToJSON(requestParameters['createRealEstateWithQuestionsCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new real estate property along with associated questionnaire responses
     * Create real estate property with questionnaire responses
     */
    async createRealEstateWithQuestions(requestParameters: CreateRealEstateWithQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createRealEstateWithQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a park (soft-delete). Linked simulations are detached and must be reconfigured.
     */
    async deleteParcRaw(requestParameters: DeleteParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['parcId'] == null) {
            throw new runtime.RequiredError(
                'parcId',
                'Required parameter "parcId" was null or undefined when calling deleteParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/{parcId}`.replace(`{${"parcId"}}`, encodeURIComponent(String(requestParameters['parcId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a park (soft-delete). Linked simulations are detached and must be reconfigured.
     */
    async deleteParc(requestParameters: DeleteParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exclude a property from the park coverage (BiensInclus) without detaching it from the park
     */
    async excludeBienFromParcCoverageRaw(requestParameters: ExcludeBienFromParcCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling excludeBienFromParcCoverage().'
            );
        }

        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling excludeBienFromParcCoverage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/biens/{bienId}/exclure`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))).replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Exclude a property from the park coverage (BiensInclus) without detaching it from the park
     */
    async excludeBienFromParcCoverage(requestParameters: ExcludeBienFromParcCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.excludeBienFromParcCoverageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this real estate
     * Get affected quotes by real estate ID
     */
    async getAffectedQuotesByRealEstateIdRaw(requestParameters: GetAffectedQuotesByRealEstateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedQuotesResponse>> {
        if (requestParameters['realEstateId'] == null) {
            throw new runtime.RequiredError(
                'realEstateId',
                'Required parameter "realEstateId" was null or undefined when calling getAffectedQuotesByRealEstateId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/{realEstateId}/devis-impactes`.replace(`{${"realEstateId"}}`, encodeURIComponent(String(requestParameters['realEstateId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedQuotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this real estate
     * Get affected quotes by real estate ID
     */
    async getAffectedQuotesByRealEstateId(requestParameters: GetAffectedQuotesByRealEstateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedQuotesResponse> {
        const response = await this.getAffectedQuotesByRealEstateIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * All matching real-estate IDs of the owner (for select-all)
     */
    async getBienIdsByProprietaireRaw(requestParameters: GetBienIdsByProprietaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BienImmobilierIdsResponse>> {
        if (requestParameters['personneId'] == null) {
            throw new runtime.RequiredError(
                'personneId',
                'Required parameter "personneId" was null or undefined when calling getBienIdsByProprietaire().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['excludeParcId'] != null) {
            queryParameters['excludeParcId'] = requestParameters['excludeParcId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/personne/{personneId}/biens-ids`.replace(`{${"personneId"}}`, encodeURIComponent(String(requestParameters['personneId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BienImmobilierIdsResponseFromJSON(jsonValue));
    }

    /**
     * All matching real-estate IDs of the owner (for select-all)
     */
    async getBienIdsByProprietaire(requestParameters: GetBienIdsByProprietaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BienImmobilierIdsResponse> {
        const response = await this.getBienIdsByProprietaireRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the simulations linked to this park that would be detached and need reconfiguration
     * Get in-progress quotes that would be impacted by deleting this park
     */
    async getDevisImpactesByParcRaw(requestParameters: GetDevisImpactesByParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedQuotesResponse>> {
        if (requestParameters['parcId'] == null) {
            throw new runtime.RequiredError(
                'parcId',
                'Required parameter "parcId" was null or undefined when calling getDevisImpactesByParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/{parcId}/devis-impactes`.replace(`{${"parcId"}}`, encodeURIComponent(String(requestParameters['parcId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedQuotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns the simulations linked to this park that would be detached and need reconfiguration
     * Get in-progress quotes that would be impacted by deleting this park
     */
    async getDevisImpactesByParc(requestParameters: GetDevisImpactesByParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedQuotesResponse> {
        const response = await this.getDevisImpactesByParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List real estate parks of the current broker
     */
    async getListParcsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadListParcsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadListParcsResponseDtoFromJSON(jsonValue));
    }

    /**
     * List real estate parks of the current broker
     */
    async getListParcs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadListParcsResponseDto> {
        const response = await this.getListParcsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Distinct property types present in a park
     */
    async getParcBienTypesRaw(requestParameters: GetParcBienTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParcBienTypesResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling getParcBienTypes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/biens/types`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParcBienTypesResponseFromJSON(jsonValue));
    }

    /**
     * Distinct property types present in a park
     */
    async getParcBienTypes(requestParameters: GetParcBienTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParcBienTypesResponse> {
        const response = await this.getParcBienTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a park with its full real-estate details
     */
    async getParcByIdRaw(requestParameters: GetParcByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetParcImmobilierResponseDto>> {
        if (requestParameters['parcId'] == null) {
            throw new runtime.RequiredError(
                'parcId',
                'Required parameter "parcId" was null or undefined when calling getParcById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/{parcId}`.replace(`{${"parcId"}}`, encodeURIComponent(String(requestParameters['parcId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetParcImmobilierResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get a park with its full real-estate details
     */
    async getParcById(requestParameters: GetParcByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetParcImmobilierResponseDto> {
        const response = await this.getParcByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the coverage configuration of a park from its risk
     */
    async getParcConfigRaw(requestParameters: GetParcConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParcConfigDto>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling getParcConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/config`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParcConfigDtoFromJSON(jsonValue));
    }

    /**
     * Get the coverage configuration of a park from its risk
     */
    async getParcConfig(requestParameters: GetParcConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParcConfigDto> {
        const response = await this.getParcConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tenancy file of a GLI park — covered properties, their tenants and per-property validity
     */
    async getParcTenancyFileRaw(requestParameters: GetParcTenancyFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParcTenancyFileResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling getParcTenancyFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/dossier-location`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParcTenancyFileResponseFromJSON(jsonValue));
    }

    /**
     * Tenancy file of a GLI park — covered properties, their tenants and per-property validity
     */
    async getParcTenancyFile(requestParameters: GetParcTenancyFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParcTenancyFileResponse> {
        const response = await this.getParcTenancyFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get real estate property by contract ID
     */
    async getRealEstateByContractIdRaw(requestParameters: GetRealEstateByContractIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRealEstateWithTenantsResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getRealEstateByContractId().'
            );
        }

        if (requestParameters['codeBranche'] == null) {
            throw new runtime.RequiredError(
                'codeBranche',
                'Required parameter "codeBranche" was null or undefined when calling getRealEstateByContractId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeQuestionnaire'] != null) {
            queryParameters['includeQuestionnaire'] = requestParameters['includeQuestionnaire'];
        }

        if (requestParameters['codeBranche'] != null) {
            queryParameters['codeBranche'] = requestParameters['codeBranche'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/contrats/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRealEstateWithTenantsResponseFromJSON(jsonValue));
    }

    /**
     * Get real estate property by contract ID
     */
    async getRealEstateByContractId(requestParameters: GetRealEstateByContractIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRealEstateWithTenantsResponse> {
        const response = await this.getRealEstateByContractIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get real estate property by ID
     */
    async getRealEstateByIdRaw(requestParameters: GetRealEstateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRealEstateResponseDto>> {
        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling getRealEstateById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeQuestionnaire'] != null) {
            queryParameters['includeQuestionnaire'] = requestParameters['includeQuestionnaire'];
        }

        if (requestParameters['codeBranche'] != null) {
            queryParameters['codeBranche'] = requestParameters['codeBranche'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/{bienId}`.replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRealEstateResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get real estate property by ID
     */
    async getRealEstateById(requestParameters: GetRealEstateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRealEstateResponseDto> {
        const response = await this.getRealEstateByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of real estate properties by person ID
     */
    async getRealEstateByPersonIdRaw(requestParameters: GetRealEstateByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadListRealEstateDto>> {
        if (requestParameters['personneId'] == null) {
            throw new runtime.RequiredError(
                'personneId',
                'Required parameter "personneId" was null or undefined when calling getRealEstateByPersonId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/personne/{personneId}`.replace(`{${"personneId"}}`, encodeURIComponent(String(requestParameters['personneId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadListRealEstateDtoFromJSON(jsonValue));
    }

    /**
     * Get list of real estate properties by person ID
     */
    async getRealEstateByPersonId(requestParameters: GetRealEstateByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadListRealEstateDto> {
        const response = await this.getRealEstateByPersonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get real estate tenants
     */
    async getTenantsRaw(requestParameters: GetTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRealEstateTenantsResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling getTenants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['bienId'] != null) {
            queryParameters['bienId'] = requestParameters['bienId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/risques/{riskId}/locataires`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRealEstateTenantsResponseFromJSON(jsonValue));
    }

    /**
     * Get real estate tenants
     */
    async getTenants(requestParameters: GetTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRealEstateTenantsResponse> {
        const response = await this.getTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-include in the park coverage a property excluded at the tenancy-file step
     */
    async includeBienInParcCoverageRaw(requestParameters: IncludeBienInParcCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling includeBienInParcCoverage().'
            );
        }

        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling includeBienInParcCoverage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/biens/{bienId}/inclure`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))).replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Re-include in the park coverage a property excluded at the tenancy-file step
     */
    async includeBienInParcCoverage(requestParameters: IncludeBienInParcCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.includeBienInParcCoverageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a real estate from a park (without unlinking it from the person)
     */
    async removeBienFromParcRaw(requestParameters: RemoveBienFromParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['parcId'] == null) {
            throw new runtime.RequiredError(
                'parcId',
                'Required parameter "parcId" was null or undefined when calling removeBienFromParc().'
            );
        }

        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling removeBienFromParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/{parcId}/biens/{bienId}`.replace(`{${"parcId"}}`, encodeURIComponent(String(requestParameters['parcId']))).replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Remove a real estate from a park (without unlinking it from the person)
     */
    async removeBienFromParc(requestParameters: RemoveBienFromParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.removeBienFromParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a person from a real estate property
     */
    async removePersonFromRealEstateRaw(requestParameters: RemovePersonFromRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling removePersonFromRealEstate().'
            );
        }

        if (requestParameters['personneId'] == null) {
            throw new runtime.RequiredError(
                'personneId',
                'Required parameter "personneId" was null or undefined when calling removePersonFromRealEstate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/{bienId}/personne/{personneId}`.replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))).replace(`{${"personneId"}}`, encodeURIComponent(String(requestParameters['personneId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Remove a person from a real estate property
     */
    async removePersonFromRealEstate(requestParameters: RemovePersonFromRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.removePersonFromRealEstateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save the coverage configuration of a park
     */
    async saveParcConfigRaw(requestParameters: SaveParcConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling saveParcConfig().'
            );
        }

        if (requestParameters['parcConfigDto'] == null) {
            throw new runtime.RequiredError(
                'parcConfigDto',
                'Required parameter "parcConfigDto" was null or undefined when calling saveParcConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/config`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ParcConfigDtoToJSON(requestParameters['parcConfigDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Save the coverage configuration of a park
     */
    async saveParcConfig(requestParameters: SaveParcConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.saveParcConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search a park\'s real estates (paginated, with optional type filter)
     */
    async searchBiensByParcRaw(requestParameters: SearchBiensByParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchBiensProprietaireResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling searchBiensByParc().'
            );
        }

        if (requestParameters['searchParcBiensCommand'] == null) {
            throw new runtime.RequiredError(
                'searchParcBiensCommand',
                'Required parameter "searchParcBiensCommand" was null or undefined when calling searchBiensByParc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/parcs-immobiliers/risques/{riskId}/biens/liste`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchParcBiensCommandToJSON(requestParameters['searchParcBiensCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchBiensProprietaireResponseFromJSON(jsonValue));
    }

    /**
     * Search a park\'s real estates (paginated, with optional type filter)
     */
    async searchBiensByParc(requestParameters: SearchBiensByParcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchBiensProprietaireResponse> {
        const response = await this.searchBiensByParcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search the owner\'s real estates (paginated), optionally excluding those already in a park
     */
    async searchBiensByProprietaireRaw(requestParameters: SearchBiensByProprietaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchBiensProprietaireResponse>> {
        if (requestParameters['personneId'] == null) {
            throw new runtime.RequiredError(
                'personneId',
                'Required parameter "personneId" was null or undefined when calling searchBiensByProprietaire().'
            );
        }

        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling searchBiensByProprietaire().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['excludeParcId'] != null) {
            queryParameters['excludeParcId'] = requestParameters['excludeParcId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/personne/{personneId}/liste`.replace(`{${"personneId"}}`, encodeURIComponent(String(requestParameters['personneId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchBiensProprietaireResponseFromJSON(jsonValue));
    }

    /**
     * Search the owner\'s real estates (paginated), optionally excluding those already in a park
     */
    async searchBiensByProprietaire(requestParameters: SearchBiensByProprietaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchBiensProprietaireResponse> {
        const response = await this.searchBiensByProprietaireRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for real estate properties using address-based criteria
     * Search real estate properties by address
     */
    async searchRealEstatesRaw(requestParameters: SearchRealEstatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchRealEstatesResponse>> {
        if (requestParameters['searchRealEstatesCommand'] == null) {
            throw new runtime.RequiredError(
                'searchRealEstatesCommand',
                'Required parameter "searchRealEstatesCommand" was null or undefined when calling searchRealEstates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRealEstatesCommandToJSON(requestParameters['searchRealEstatesCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRealEstatesResponseFromJSON(jsonValue));
    }

    /**
     * Search for real estate properties using address-based criteria
     * Search real estate properties by address
     */
    async searchRealEstates(requestParameters: SearchRealEstatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchRealEstatesResponse> {
        const response = await this.searchRealEstatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a real estate property along with associated questionnaire responses
     * Update real estate property with questionnaire responses
     */
    async updateRealEstateWithQuestionsRaw(requestParameters: UpdateRealEstateWithQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['bienId'] == null) {
            throw new runtime.RequiredError(
                'bienId',
                'Required parameter "bienId" was null or undefined when calling updateRealEstateWithQuestions().'
            );
        }

        if (requestParameters['updateRealEstateWithQuestionsCommandDto'] == null) {
            throw new runtime.RequiredError(
                'updateRealEstateWithQuestionsCommandDto',
                'Required parameter "updateRealEstateWithQuestionsCommandDto" was null or undefined when calling updateRealEstateWithQuestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/biens-immobiliers/{bienId}/details`.replace(`{${"bienId"}}`, encodeURIComponent(String(requestParameters['bienId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRealEstateWithQuestionsCommandDtoToJSON(requestParameters['updateRealEstateWithQuestionsCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Updates a real estate property along with associated questionnaire responses
     * Update real estate property with questionnaire responses
     */
    async updateRealEstateWithQuestions(requestParameters: UpdateRealEstateWithQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateRealEstateWithQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
